module.exports = __webpack_public_path__ + "static/img/img-features-feature-2-game-8@2x.1449607.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-2-game-8@2x.png
// module id = jP7M
// module chunks = 18